import { RouteRecordRaw } from "vue-router";

import usePermissions from "@/hooks/use-permissions";
import ClassesCatalogImportPage from "@/pages/games/GameDisplay/children/classes/ClassesCatalogImport/ClassesCatalogImportPage.vue";
import ClassesListPage from "@/pages/games/GameDisplay/children/classes/ClassesList/ClassesListPage.vue";
import ClassFormPage from "@/pages/games/GameDisplay/children/classes/ClassForm/ClassFormPage.vue";

import links from "./links";

const { canReadClasses, canWriteClasses, canReadClassesCatalog } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: "new",
    name: links.games.classes.new,
    component: ClassFormPage,
    props: true,
    meta: {
      title: "New class",
      permission: canWriteClasses,
    },
  },
  {
    path: ":classId/preview",
    name: links.games.classes.preview,
    component: ClassFormPage,
    props: (route) => ({ ...route.params, preview: true }),
    meta: {
      title: "Preview class",
      permission: canReadClasses,
    },
  },
  {
    path: ":classId/edit",
    name: links.games.classes.edit,
    component: ClassFormPage,
    props: true,
    meta: {
      title: "Edit class",
      permission: canWriteClasses,
    },
  },
  {
    path: "",
    name: links.games.classes.list,
    component: ClassesListPage,
    props: true,
    meta: {
      title: "Classes",
      permission: canReadClasses,
    },
    children: [
      {
        path: "import",
        component: ClassesCatalogImportPage,
        name: links.games.classes.importFromCatalog,
        props: true,
        meta: {
          title: "Import classes from catalog",
          permission: canReadClassesCatalog,
        },
      },
    ],
  },
];
